/* globals Flickity, PLUG */
(function () {
  class PlugArticlesSlider extends HTMLElement {
    constructor() {
      super();

      this.slider = undefined;
      this.dynamicallyLoadArticles = (this.dataset.fromSectionBlocks === 'false');
      this.numArticlesInBlog = this.dataset.numArticlesInBlog;
      this.elements = {
        list: this.querySelector('.plug-articles-slider__list'),
        listWrapper: this.querySelector('.plug-articles-slider__list-wrapper'),
        previousButton: this.querySelector('.plug-articles-slider__slider-btn.previous'),
        nextButton: this.querySelector('.plug-articles-slider__slider-btn.next'),
        seeMoreButton: this.querySelector('.plug-articles-slider__see-more-btn')
      };

      this.init = this.init.bind(this);
      this.fetchPageOfArticles = this.fetchPageOfArticles.bind(this);
      this.createArticleSlide = this.createArticleSlide.bind(this);
      this.initSeeMoreButton = this.initSeeMoreButton.bind(this);
      this.initSliderButtons = this.initSliderButtons.bind(this);
      this.buildSlider = this.buildSlider.bind(this);
      this.destroySlider = this.destroySlider.bind(this);

      if (this.dynamicallyLoadArticles) {
        this.articleTags = this.dataset.articleTags.split(', ');

        const parseq = PLUG.Parseq.export();
        window.addEventListener('DOMContentLoaded', () => {
          const requestors = [];
          let k = 0;
          while (k < this.numArticlesInBlog) {
            requestors.push(this.fetchPageOfArticles(k + 1));
            k += 1;
          }
          parseq.parallel(requestors)((results, err) => {
            if (err) throw err;
            let articles = [];
            results.forEach((pageOfArticles) => {
              articles = articles.concat(pageOfArticles);
            });
            this.articleSlideModel = this.querySelector('.plug-article-slide--model');
            this.articleSlideModel.classList.remove('hidden');
            this.articleSlideModel.parentElement.removeChild(this.articleSlideModel);

            const articlesWithAllMatchingTags = [];
            const articlesWithSomeMatchingTags = [];
            let j = 0;
            while (j < articles.length) {
              const articleJ = articles[j];
              if (this.articleTags.every(tag => articleJ.tags.includes(tag))) {
                articlesWithAllMatchingTags.push(articleJ);
              } else if (this.articleTags.some(tag => articleJ.tags.includes(tag))) {
                articlesWithSomeMatchingTags.push(articleJ);
              }
              j += 1;
            }

            if (articlesWithAllMatchingTags.length + articlesWithSomeMatchingTags.length <= 4) {
              this.classList.add('hidden');
            } else {
              const docFrag = document.createDocumentFragment();
              let articles = articlesWithAllMatchingTags;
              if (articles.length < 6) {
                let n = 0;
                while (n < (6 - articles.length) && n < articlesWithSomeMatchingTags.length) {
                  articles.push(articlesWithSomeMatchingTags[n]);
                  n += 1;
                }
              }
              if (articles.length > 10) {
                articles = articles.slice(0, 10);
              }
              articles.forEach((article) => {
                docFrag.appendChild(this.createArticleSlide(article.title, article.image, article.url));
              });
              this.elements.list.appendChild(docFrag);
              this.init();
            }
          });
        });
      } else {
        this.init();
      }
    }

    createArticleSlide(title, image, url) {
      let titleWords = title.split(' ');
      if (titleWords > 8) {
        titleWords = titleWords.slice(0, 8);
      }
      const slide = this.articleSlideModel.cloneNode(true);
      slide.querySelector('.plug-article-slide__thumbnail').href = url;
      slide.querySelector('.plug-link').href = url;
      const img = document.createElement('img');
      img.className = 'ratio-img fit-cover';
      img.setAttribute('srcset', image.srcset);
      img.setAttribute('src', image.src);
      img.setAttribute('loading', 'lazy');
      img.width = image.width;
      img.height = image.height;
      img.alt = image.alt;
      slide.querySelector('.ratio-box').appendChild(img);
      slide.querySelector('.plug-article-slide__title .plug-link').textContent = titleWords.join(' ');
      return slide;
    }

    fetchPageOfArticles(pageNum) {
      return function (cb) {
        try {
          let path = window.location.pathname.split('/');
          path.pop();
          path = path.join('/');
          PLUG.getFreshSection('plug-blog-data', (section, err) => {
            if (err) throw err;
            const articles = JSON.parse(section.getElementsByTagName('script')[0].innerHTML).articles;
            return cb(articles);
          }, path, '?page=' + pageNum);
        } catch (exception) {
          return cb(undefined, exception);
        }
      };
    }

    init() {
      if (!this.isMobile()) {
        this.buildSlider();
      }
      this.initSeeMoreButton();
      this.initSliderButtons();

      let resizeTimer;
      window.addEventListener('resize', () => {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(() => {
          let mobile = this.isMobile();
          if (!mobile && !this.slider) {
            this.buildSlider();
          } else if (mobile && this.slider) {
            this.destroySlider();
          }
        }, 200);
      });
    }

    buildSlider() {
      this.slider = new Flickity(this.elements.list, {
        cellAlign: 'left',
        wrapAround: false,
        contain: true,
        pageDots: false,
        prevNextButtons: false
      });

      this.slider.on('change', (index) => {
        this.elements.previousButton.disabled = (index === 0);
        this.elements.nextButton.disabled = (index >= this.slider.cells.length - 3);
      });
    }

    destroySlider() {
      if (this.slider) {
        this.slider.destroy();
        this.slider = undefined;
      }
    }

    initSeeMoreButton() {
      this.elements.seeMoreButton.addEventListener('click', () => {
        const wasExpanded = this.elements.listWrapper.classList.contains('is-expanded');
        const seeMoreLink = this.querySelector('.plug-articles-slider__see-more-link');
        if (!wasExpanded && seeMoreLink) {
          this.elements.seeMoreButton.classList.add('hidden');
          seeMoreLink.classList.remove('hidden');
        }
        this.elements.listWrapper.classList.toggle('is-expanded');
      });
    }

    initSliderButtons() {
      this.elements.previousButton.addEventListener('click', () => {
        this.slider.previous(false, false);
        this.elements.nextButton.disabled = false;
      });
      this.elements.nextButton.addEventListener('click', () => {
        this.slider.next(false, false);
        this.elements.previousButton.disabled = false;
      });
    }

    isMobile() {
      return window.innerWidth < 990;
    }
  }

  customElements.define('plug-articles-slider', PlugArticlesSlider);

  // function getHeightOfHiddenElement(element, callback) {
  //   const clone = element.cloneNode(true);
  //   clone.style.position = 'absolute';
  //   clone.style.display = 'block';
  //   clone.style.opacity = '0';
  //   clone.style.left = '0';
  //   clone.style.right = '0';
  //   clone.style.top = '0';
  //
  //   const parent = element.parentElement;
  //   const parentStyles = window.getComputedStyle(parent);
  //   const parentPosition = parentStyles.getPropertyValue('position');
  //   parent.style.position = (parentPosition === 'static') ? 'relative' : parentPosition;
  //
  //   parent.appendChild(clone);
  //
  //   window.requestAnimationFrame(() => {
  //     setTimeout(() => {
  //       const elementHeight = clone.getBoundingClientRect().height;
  //       parent.removeChild(clone);
  //       return callback(elementHeight);
  //     }, 0);
  //   });
  // }
})();
